import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { InstituteModel } from '../model/institute.model';

@Injectable()
export class InstituteService {

  path = '/institute';

  constructor(private baseService: BaseService) { }
    
  getById(id: number) {
    return this.baseService.get(this.path, '/' + id, {});
  }

  getPaginated(query: { init, end, city?, name? }) {
    return this.baseService.get(this.path, '', query);
  }

  post(institute: InstituteModel) {
    return this.baseService.post(this.path, '/', institute);
  }

  put(institute: InstituteModel) {
    return this.baseService.put(this.path, '/', institute);
  }

  delete(id: number) {
    return this.baseService.delete(this.path, '/' + id);
  }

  save(institute: InstituteModel) {
    if (institute.id) { return this.put(institute); } else { return this.post(institute); }
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/institute.service.ts